import arrayMerge from 'utils/arrayMerge'
import client from 'utils/datadogService'
import { Computed, computed, Thunk, thunk } from 'easy-peasy'
import { StoreModel } from '../index'

export interface Metric {
  name: string
  value: number
  tags?: string[]
}

export interface DatadogModel {
  defaultTags: Computed<DatadogModel, string[], StoreModel>

  increment: Thunk<DatadogModel, Metric>
  histogram: Thunk<DatadogModel, Metric>
}

const datadog: DatadogModel = {
  defaultTags: computed(
    [
      (state, storeState) => storeState['dimensions'].dimensions.mortgageType,
      (state, storeState) => storeState['dimensions'].dimensions.zipCode,
      (state, storeState) => storeState['location'].location.state,
      (state, storeState) => storeState['dimensions'].isDesktop,
      (state, storeState) => storeState['dimensions'].dimensions.refinance.cashOutAmount,
    ],
    (mortgageType, zipCode, state, isDesktop, cashOutAmount) => {
      let tags = [
        'clientenv:' + process.env.REACT_APP_ENV,
        'device_type:' + (isDesktop ? 'desktop' : 'mobile'),
        'product_type:' + mortgageType,
        'state:' + state,
        'zip:' + zipCode,
        'table:react',
      ]

      if (mortgageType === 'Refinance') {
        const isCashOut = cashOutAmount ? true : false
        tags.push(`isCashOut:${isCashOut}`)
      }

      return tags
    }
  ),

  histogram: thunk(async (actions, metric, { getState, fail }) => {
    try {
      metric.tags = arrayMerge(metric.tags, getState().defaultTags)

      await client.get(`/histogram/${metric.name}/${metric.value}/${metric.tags.join(',')}`)
    } catch (e) {
      fail(e)
    }
  }),

  increment: thunk(async (actions, metric, { getState, fail }) => {
    try {
      metric.tags = arrayMerge(metric.tags, getState().defaultTags)

      await client.get(`/increment/${metric.name}/${metric.value}/${metric.tags.join(',')}`)
    } catch (e) {
      fail(e)
    }
  }),
}

export default datadog
